export const ResultCode = {
  SUCCESS: 0,
  SYNTAX_ERROR: 1,
  VALIDATION_ERROR: 2
};

export const ErrorCode = {
  NO_ERROR: 0,
  EMPTY: 1,
  INCLUDE_NG_WORD: 2,
  DENY_NEGATIVE_NUM: 3,
  DENY_ZERO_NUM: 4,
  NOT_ENOUGH_LENGTH: 5,
  OVER_MAX_VAL: 6,
  UNDER_MIN_VAL: 7,
  OVER_MAX_LEN: 8,
  UNDER_MIN_LEN: 9
};

export const NGwords = [
  '死',
  'バカ',
  'クリトリス',
  'ｸﾘﾄﾘｽ',
  'SEX',
  'せっくす',
  'セックス',
  'ｾｯｸｽ',
  'おっぱい',
  'オッパイ',
  'ｵｯﾊﾟｲ',
  'まんこ',
  'マンコ',
  'ﾏﾝｺ',
  'まんげ',
  'マンゲ',
  'ﾏﾝｹﾞ',
  'うんこ',
  'ｳﾝｺ',
  'ちんぽ',
  'ﾁﾝﾎﾟ',
  'パイズリ',
  'ﾊﾟｲｽﾞﾘ',
  'スカトロ',
  '射精',
  '巨乳',
  '貧乳',
  'ちんこ',
  'チンコ',
  'ﾁﾝｺ',
  'ちんちん',
  'チンチン',
  'ﾁﾝﾁﾝ',
  'ちんげ',
  'チンゲ',
  'クソ',
  'ｸｿ',
  '糞',
  'ゴミ',
  'ｺﾞﾐ',
  'カス',
  'ｶｽ',
  'エッチ',
  'ヤリマン',
  '淫乱',
  '肉便器',
  'オナニー',
  'ババア',
  'ジジイ',
  '鼻くそ',
  '鼻糞',
  '==',
  '    ',
  '　　　　',
  'script',
  '<?',
  '<php',
  'null',
  'NaN',
  'undefined',
  'true',
  ';',
  'alert(',
  '</',
  'false'
];
